import { Controller } from "stimulus"

export default class extends Controller {
  // static targets = ["form"]

  connect() {
    // console.log('connected to flash controller')
    this.show()
  }

  show() {
    this.element.classList.toggle("opacity-0")
    this.element.classList.toggle("opacity-100")
    setTimeout(() => {
      this.hide()
    }, 3000);
  }

  hide() {
    this.element.classList.toggle("opacity-0")
    this.element.classList.toggle("opacity-100")
  }
}
